define('shared/util/dispatchers/retrievers/query',['shared/lib/RSVP', 'shared/lib/URI'], function( RSVP, URI ){
    'use strict';
    var uri, query, uriLower, queryLower;

    /* Privates */
    function init(){
        if ( query || uri ) {
            return;
        }

        uri = new URI( location.href );
        query = uri.query( true );

        uriLower = new URI( location.href.toLowerCase() );
        queryLower = uriLower.query( true );
    }

    return function ( key, options ) {
        return new RSVP.Promise(function(resolve){
            init();
            var value = null;
            if ( options.caseSensitive === false ) {
                value = queryLower[key.toLowerCase()];
            }
            else {
                value = query[key];
            }

            if (value && options.format) {
                var a = window.document.createElement('a');
                a.href = value;
                value = '';
                for(var i = 0; i < options.format.length; i++) {
                    value += a[options.format[i]];
                }
            }

            resolve(value);

        });
    };
});
